import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Card from "../components/card"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

const CdpFeaturedPosts = () => {
  const data = useStaticQuery(
    graphql`
      query CdpFeaturedPostsQuery {
        allMarkdownRemark(
          sort: { order: DESC, fields: [frontmatter___cdp_featured] }
          filter: {
            frontmatter: { cdp_featured: { ne: null } }
            fields: { meta: { draft: { eq: false } } }
          }
        ) {
          nodes {
            fields {
              meta {
                slug
              }
            }
            frontmatter {
              date(formatString: "YYYY.MM.DD")
              title
              description
              tags
              cover {
                childImageSharp {
                  gatsbyImageData(width: 800, formats: AUTO)
                }
              }
            }
            id
          }
        }
      }
    `
  )

  const posts = data.allMarkdownRemark.nodes

  if(posts.length === 0) return (<div></div>)

  const settings = {
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3500,
    centerPadding: 0,
    cssEase: 'linear',
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    responsive: [
      {
        breakpoint: 2100, //画面幅がこの数値以下の場合の設定
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1
        }
      }
    ],
    slidesToScroll: 1
  }

  return (
    <div className="lg:mt-8 lg:pt-8 slider-container">
      <Slider {...settings}>
        {posts.map(post => (
          <Card key={post.id} post={post} size="l" className="card-container" />
        ))}
      </Slider>
    </div>
  )
}

export default CdpFeaturedPosts
